import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { adminSubscriptionTransactionsService } from "@/services/admin-subscription-transactions-service";
import { normalizeSubscriptionTransactionsResponse } from "@/services/subscription-transactions-adapter";
import { AdminSubscriptionTransactionFilters } from "@/types/subscription-transactions";

export const adminSubscriptionTransactionKeys = {
  all: ["adminSubscriptionTransactions"] as const,
  lists: () => [...adminSubscriptionTransactionKeys.all, "list"] as const,
  list: (filters?: AdminSubscriptionTransactionFilters) =>
    [...adminSubscriptionTransactionKeys.lists(), filters] as const,
};

export const useAdminSubscriptionTransactions = (
  enabled: boolean,
  filters?: AdminSubscriptionTransactionFilters,
) =>
  useQuery({
    queryKey: adminSubscriptionTransactionKeys.list(filters),
    queryFn: async () => {
      const response =
        await adminSubscriptionTransactionsService.getTransactions(filters);

      return normalizeSubscriptionTransactionsResponse(response, filters);
    },
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
    enabled,
  });
